export default class FacetFiltersRenderer {
  constructor(facets, sorts) {
    this.facets = facets
    this.sorts = sorts
  }
}
export const buildSorts = (sorts, showMoreLimit, callback) => {
  const container = $('#searchResults .filters-wrap')
  const html = Handlebars.getSharedTemplate('sortComponent')({
    items: sorts,
    showMoreLimit: showMoreLimit,
  })
  container.prepend(html)
  if (callback) callback()
}
export const buildSimpleFiltersComponent = (
  filterObj,
  isSubFilter,
  showMoreLimit
) => {
  let html = ''
  let compiledTemplate
  if (filterObj.code === 'otherFilters') {
    compiledTemplate = Handlebars.getSharedTemplate('boxFilterComponent')
  } else {
    compiledTemplate = Handlebars.getSharedTemplate('filterComponent')
  }
  const resultHtml = compiledTemplate({
    item: filterObj,
    isSubFilter,
    showMoreLimit,
  })
  html = html.concat(resultHtml)
  return html
}
export const buildFilterTag = (name, value) => {
  let html = ''
  const compiledTemplate = Handlebars.getSharedTemplate('filterTag')
  const resultHtml = compiledTemplate({
    item: { name, value },
  })
  html = html.concat(resultHtml)
  return html
}
export const buildPriceRangeComponent = (item) => {
  let html = ''
  const compiledTemplate = Handlebars.getSharedTemplate('filterRangeComponent')
  const resultHtml = compiledTemplate({ item })
  html = html.concat(resultHtml)
  return html
}
